import { faLockKeyhole } from '@fortawesome/pro-duotone-svg-icons'
import { Stack } from '@mui/material'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { STAKING_URL } from '../../../constants/navigation'
import { buildKYCStatus, KYC_STAGE } from '../../../util/kyc.helpers'
import RefreshButton from '../../shared/button/RefreshButton'
import Popup from '../../shared/popup/Popup'
import KYCAlert from '../../userAccount/KYCAlert'
import TierRequirementBox from '../../shared/purchaseStatus/TierRequirementBox'
import MembershipRequirement from '../../shared/purchaseStatus/MembershipRequirement'
import { calcMembershipStatusProgress } from '../../../util/staking/membership.helpers'
import PurchaseStatusButton from '../../shared/purchaseStatus/PurchaseStatusButton'
import Button from '../../shared/button/Button'

const FeatureLocked = ({
  onSubmit,
  onCancel,
  mainProfile: { userTier },
  kycProfile: { id, status, isProcessing, isRefreshing },
  onContinueKYC,
  tierRequirement,
  checkKyc,
  onRefreshKYC
}) => {
  const isKycSuccess = status === KYC_STAGE.SUCCESS
  const { t } = useTranslation()
  const { severity, title, support, disabled, hide, refresh } = buildKYCStatus({
    id,
    status
  })
  const { current, total, completed } = calcMembershipStatusProgress({
    userTier,
    tierRequirement
  })
  const requirements = [
    ...(tierRequirement?.fiatThreshold
      ? [
          {
            title: t('kyc.tier-status-required', {
              tier: tierRequirement?.name
            }),
            completed: userTier.tier.id === tierRequirement?.id,
            desc: (
              <MembershipRequirement
                t={t}
                id={tierRequirement?.id}
                current={current}
                total={total}
                completed={completed}
              />
            ),
            refresh: !(completed >= 100) && (
              <Button
                label={t('brand:staking.stake')}
                component={Link}
                to={STAKING_URL}
                onClick={onCancel}
              />
            ),
            action: <PurchaseStatusButton t={t} />
          }
        ]
      : []),
    ...(checkKyc
      ? [
          {
            title: t('kyc.verification-required'),
            completed: isKycSuccess,
            desc: (
              <KYCAlert
                t={t}
                severity={severity}
                title={title}
                support={support}
                sx={{ mb: 0.6, ml: { sm: 5, xs: 0 } }}
              />
            ),
            refresh: refresh && (
              <RefreshButton
                t={t}
                onClick={onRefreshKYC}
                loading={isRefreshing}
              />
            ),
            action: !hide && (
              <Button
                label={t('kyc.complete-kyc')}
                onClick={onContinueKYC}
                loading={isProcessing}
                disabled={disabled}
              />
            )
          }
        ]
      : [])
  ]
  return (
    <Popup
      title={t('kyc.this-feature-is-locked')}
      description={t('kyc.to-unlock-fulfill-requirements')}
      icon={faLockKeyhole}
      submitLabel={t('common.close')}
      onFormSubmit={onSubmit}
      onCancel={onCancel}
    >
      <Stack spacing={2}>
        {requirements.map((props, index) => (
          <TierRequirementBox key={index} {...props} />
        ))}
      </Stack>
    </Popup>
  )
}

export default memo(FeatureLocked)
